export default __webpack_public_path__ + "static/media/speaker4.6effe56e.jpg";